export enum NotFoundType {
  DEFAULT = '',
  PROJECT_NOT_FOUND = 'projectNotFound',
  PROJECT_UNAUTHORIZED = 'projectUnauthorized',
  SESSION_EXPIRED = 'session/expired',
}
